// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1mEIe","title":"Header_title__3ADAL","side":"Header_side__rEp_p"};